import { CurrencyPipe, DatePipe } from '@angular/common';
import {
  Component,
  effect,
  inject,
  model,
  OnInit,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IClienteDeuda } from '@core/interfaces/entidades/cliente.entidad';
import { IPaginar } from '@core/interfaces/paginacion/paginacion.interface';
import { IVerDeudaClienteCreditoRes } from '@core/interfaces/request-response/credito.dto.interface';
import { ITablaColumna } from '@core/interfaces/tabla.interface';
import { CreditoApiService } from '@core/services/api/credito-api.service';
import { environment } from '@env/environment';
import { InputBuscador } from '@shared/components/input-buscador/input-buscador';
import { Paginacion } from '@shared/components/paginacion/paginacion';
import { Tabla } from '@shared/components/tabla/tabla';
import { AppService } from '@shared/services/app.service';
import { SucursalService } from '@shared/services/sucursal.service';
import { UiButton, UiTooltip } from '@shared/components/ui';

@Component({
  selector: 'app-ver-creditos',
  imports: [InputBuscador, UiButton, Tabla, Paginacion, CurrencyPipe, UiTooltip],
  templateUrl: './ver-creditos.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ver-creditos.css',
})
export class VerCreditos implements OnInit {
  constructor() {
    effect(() => {
      if (this.sucursalService.sucursalReady() && this.appService.authReady()) {
        this.clienteId = Number(this.activatedRoute.snapshot.paramMap.get('clienteId') || 0);
        if (this.clienteId) {
          this.creditoApiService
            .verDeudaCliente(this.clienteId, 1, this.itemsPorPagina)
            .subscribe((res) => {
              this.paginacion.set({
                data: res.data,
                pagina: res.pagina,
                total: res.total,
                size: res.size,
              });
            });
        }
      }
    });
  }

  ngOnInit(): void {
    this.appService.setPanelHeader({
      title: 'Créditos del Cliente',
      subtitle: 'Aquí puedes gestionar los créditos del cliente',
      showBackButton: true,
    });
    this.columnasTabla = [
      { key: 'documento', titulo: 'Documento' },
      { key: 'fecha', titulo: 'Fecha', pipe: new DatePipe(environment.locale) },
      { key: 'total', titulo: 'Total', pipe: new CurrencyPipe(environment.locale, 'PEN') },
      { key: 'pagado', titulo: 'Pagado', pipe: new CurrencyPipe(environment.locale, 'PEN') },
      { key: 'saldo', titulo: 'Saldo', pipe: new CurrencyPipe(environment.locale, 'PEN') },
      { key: 'estado', titulo: 'Estado' },
    ];
  }
  // servicios
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private creditoApiService = inject(CreditoApiService);
  private appService = inject(AppService);
  private sucursalService = inject(SucursalService);

  // datos
  private itemsPorPagina = 18;
  busqueda = model('');
  columnasTabla: ITablaColumna[] = [];
  paginacion = signal<IPaginar<IVerDeudaClienteCreditoRes> | null>(null);
  clienteId: number = 0;

  // métodos
  onBuscar() {}
  cambiarPagina(page: number) {}
  verDetalle(row: IClienteDeuda) {
    this.router.navigate(['/panel/gestion/creditos/ver/detalle', row.id]);
  }
}
